export const getErrorMessageContent = (
  errorType: string,
  language: string
): string => {
  if (errorType === "TechError") {
    if (language === "en") {
      return `<div>
          <div>An error occurred.</div>
          <div>
            Please reach out to our support team if this issue persists.
          </div>
        </div>`;
    }

    if (language === "es") {
      return `<div>
          <div>Se produjo un error.</div>
          <div>
            Comunícate con nuestro equipo de soporte si el problema persiste.
          </div>
        </div>`;
    }
  }
  if (errorType === "AuthorizationError") {
    if (language === "en") {
      return `<div>
          <div>You do not have necessary permissions to access this page. </div>
          <div>
            If you want to be considered for the program, please reach out to
            your doctor for further assistance.
          </div>
        </div>`;
    }

    if (language === "es") {
      return `<div>
          <div>
            No tienes los permisos necesarios para acceder a esta página. 
          </div>
          <div>
            Si deseas ser considerada para el programa, comunícate con tu médico
            para recibir orientación. 
          </div>
        </div>`;
    }
  }

  return " "; // fallback for unsupported error types or languages
};
